<template>
  <div class="speaker">
    <div class="container">
      <ShadowTitle class="d-flex d-md-none"
                   :title="`Спикеры мероприятия`"
                   title-shadow="HEROES ELS SPACE"
      />
      <div class="speaker-wrap _2">
        <div class="speaker-head _mobile"/>
        <div class="speaker-content">
          <div class="speaker-image">
            <img class="img-fluid" :src="require(`@/assets/speaker-bg-2.png`)">
          </div>
          <div class="speaker-body">
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text">
                Основатель «Master Space. Самопознание»
              </div>
            </div>
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text">
                Основатель China Campus Network — лидер рынка обучения в Китае
              </div>
              <div class="speaker-desc-logo">
                <img class="img-fluid" :src="require(`@/assets/logos/china-campus.svg`)">
              </div>
            </div>
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text">
                Сооснователь компаний <br>по кибербезопасности CyberEd <br>и Singletone Security
              </div>
              <div class="speaker-desc-logo">
                <img class="img-fluid" :src="require(`@/assets/logos/cyberED.svg`)">
              </div>
            </div>
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text w-100">
                Чемпион Мира 2023 (Токио), Чемпион России 2021 и 2022  по карате Киокушинкай, 1 дан чёрный пояс
              </div>
            </div>
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text w-100">
                Управляющий партнер инвест. группы «HumanTek»
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="speaker-wrap _3">
        <div class="speaker-head _mobile"/>
        <div class="speaker-content">
          <div class="speaker-image">
            <img class="img-fluid" :src="require(`@/assets/speaker-bg-3.png`)">
          </div>
          <div class="speaker-body">
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text w-100">
                Супервизор. Тренер
              </div>
            </div>
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text w-100">
                Основатель психологического центра
              </div>
            </div>
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text w-100">
                Преподаватель психологии
              </div>
            </div>
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text w-100">
                Автор международных программ по подготовке практикующих психологов
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="speaker-wrap _4">
        <div class="speaker-head _mobile"/>
        <div class="speaker-content">
          <div class="speaker-image">
            <img class="img-fluid" :src="require(`@/assets/speaker-bg-4.png`)">
          </div>
          <div class="speaker-body">
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text ">
                Основатель учебного центра здоровья «СФЕРА АТМА»
              </div>
            </div>
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text ">
                Создатель интегральной оздоровительной методики «АЛМАЗНОЕ ЗДОРОВЬЕ»
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="speaker-wrap _5">
        <div class="speaker-head _mobile"/>
        <div class="speaker-content">
          <div class="speaker-image">
            <img class="img-fluid" :src="require(`@/assets/speaker-bg-5.png`)">
          </div>
          <div class="speaker-body">
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text w-100">
                Основатель лаборатории организационного дизайна «Здравый Смысл»
              </div>
            </div>
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text w-100">
                Со-организатор конференции «Живая Компания»
              </div>
            </div>
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text w-100">
                Практик социальной технологии Социократия 3.0
              </div>
            </div>
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text w-100">
                Визионер организаций будущего
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="speaker-wrap _6">
        <div class="speaker-head _mobile"/>
        <div class="speaker-content">
          <div class="speaker-image">
            <img class="img-fluid" :src="require(`@/assets/speaker-bg-6.png`)">
          </div>
          <div class="speaker-body">
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text w-100">
                Бизнес-тренер, мастер нейротрансформации, бизнес-психолог, сертифицированный коуч ICPA, ведущая стратегических сессий для корпораций
              </div>
            </div>
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text w-100">
                Спикер международных конференций и автор обучающих программ для владельцев бизнеса и топ-менеджеров
              </div>
            </div>
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text w-100">
                Предприниматель с 20-летним стажем (оптово-розничный бизнес с производством в Китае, Турции, Индии, Пакистане)
              </div>
            </div>
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text w-100">
                Автор бизнес-романа «Почему бы и «Да!»
              </div>
            </div>
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text w-100">
                Основатель международной нейрокоучинговой системы для предпринимателей «Мысли как Тесла»
              </div>
            </div>
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text w-100">
                Создатель программы по выходу из выгорания через изменение качества мышления и уровня персональной энергии «Энергия. Выгорание. Мозг»
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="speaker-wrap _7">
        <div class="speaker-head _mobile"/>
        <div class="speaker-content">
          <div class="speaker-image">
            <img class="img-fluid" :src="require(`@/assets/speaker-bg-7.png`)">
          </div>
          <div class="speaker-body">
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text w-100">
                Кинорежиссер, автор 4-х документальных фильмов о развитии человека и около 100 интервью с ведущими мировыми экспертами по этой теме
              </div>
            </div>
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text w-100">
                Президент Ассоциации трансперсональной психологии и психотерапии
              </div>
            </div>
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text w-100">
                Кандидат философских наук, доцент Московского института психоанализа, руководитель программ по трансперсональной психологии, психотерапии и коучингу
              </div>
            </div>
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text w-100">
                Член Президиума EUROTAS (Европейской трансперсональной ассоциации)
              </div>
            </div>
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text w-100">
                Главный редактор серии «Тексты трансперсональной психологии»
              </div>
            </div>
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text w-100">
                Руководитель тренинга наследия Грофа в России, пионер холотропного дыхания
              </div>
            </div>
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text w-100">
                Сертифицированный специалист по процессуальной работе, сертифицированный психотерапевт Всемирного совета по психотерапии, Европейской ассоциации психотерапии и Европейской трансперсональной ассоциации
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="speaker-wrap _8">
        <div class="speaker-head _mobile"/>
        <div class="speaker-content">
          <div class="speaker-image">
            <img class="img-fluid" :src="require(`@/assets/speaker-bg-8.png`)">
          </div>
          <div class="speaker-body">
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text w-100">
                Номинант премии «Золотая маска»
              </div>
            </div>
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text w-100">
                84 картины в профессиональной карьере
              </div>
            </div>
            <div class="speaker-desc-item mb-3">
              <div class="speaker-desc-text w-100">
                Проведет поэтически-музыкальный вечер для участников SPACE EVENT
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ShadowTitle from "@/components/ShadowTitle";

export default {
  name: "Speaker2",
  components: {ShadowTitle}
}
</script>
<style lang="scss" scoped>
.speaker-wrap {
  position: relative;
  background: linear-gradient(339.26deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 8.85%, rgba(255, 255, 255, 0) 86.98%, rgba(255, 255, 255, 0.08) 100%),
  linear-gradient(0deg, #0D0D10, #0D0D10);
  box-shadow: 0 4px 76px 0 #00000099;
  border-radius: 16px;
  &:not(:last-child) {
    margin-bottom: 32px;
    @include _992 {
      margin-bottom: 80px;
    }
  }
  @include _992 {
    padding: 0;
    background: none;
    box-shadow: none;
  }

  .speaker-content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: start;
    position: relative;
  }

  .speaker-image {
    overflow: hidden;
    background: #0D0D10;
    border-radius: 16px;
    box-shadow: 0 4px 76px 0 #00000099;
    display: none;
    width: 100%;
    transition: all 0.3s;

    @include _992 {
      width: 48%;
      display: flex;
    }
  }

  .speaker-body {
    position: relative;
    z-index: 5;
    width: 100%;
    padding: 100% 1rem 1rem 1rem;
    @include _992 {
      width: 48%;
      padding: 0;
    }
  }
}

.speaker-head {
  height: 100%;
  width: 100%;
  background: url(~@/assets/speaker-bg-mob.png) no-repeat top center;
  background-size: 100%;
  border-radius: 16px;
  position: absolute;
  top: 0;
  z-index: 1;
  @include _992 {
    display: none;
  }
}

.speaker-desc-item {
  border-radius: 16px;
  background: var(--deep-dark, #1B1B21);
  display: flex;
  flex-direction: column;
  padding: 24px 18px;
  align-items: center;
  @include _576 {
    flex-direction: row;
    justify-content: space-between;
  }

  .speaker-desc-text {
    width: 100%;
    color: var(--gray, #C7C7D1);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 128%; /* 20.48px */

    br {
      display: none
    }

    @include _576 {
      width: 60%;
      br {
        display: block
      }
    }
    @include _768 {
      margin-bottom: 0;
    }
  }

  .speaker-desc-logo {
    width: 100%;
    display: flex;
    margin-top: 8px;
    @include _576 {
      width: 40%;
      align-items: center;
      justify-content: center;
    }
  }
}

.speaker-wrap {
  &._2 {
    .speaker-head {
      background: url(~@/assets/speaker-bg-2-mob.png) no-repeat top center;
      background-size: 100%;
    }
  }
  &._3 {
    .speaker-head {
      background: url(~@/assets/speaker-bg-3-mob.png) no-repeat top center;
      background-size: 100%;
    }
  }
  &._4 {
    .speaker-head {
      background: url(~@/assets/speaker-bg-4-mob.png) no-repeat top center;
      background-size: 100%;
    }
  }
  &._5 {
    .speaker-head {
      background: url(~@/assets/speaker-bg-5-mob.png) no-repeat top center;
      background-size: 100%;
    }
  }
  &._6 {
    .speaker-head {
      background: url(~@/assets/speaker-bg-6-mob.png) no-repeat top center;
      background-size: 100%;
    }
  }
  &._7 {
    .speaker-head {
      background: url(~@/assets/speaker-bg-7-mob.png) no-repeat top center;
      background-size: 100%;
    }
  }
  &._8 {
    .speaker-head {
      background: url(~@/assets/speaker-bg-8-mob.png) no-repeat top center;
      background-size: 100%;
    }
  }
}
</style>